import { filter, map, of, tap } from 'rxjs';
import { Injector } from '@angular/core';
import { SubscriptionResponse } from '../subscription.service';
import { AppStateService } from 'shared/services/app-state/app-state.service';

export const handle = (injector: Injector, response: SubscriptionResponse) => {
  const appState = injector.get(AppStateService);
  return of(response).pipe(
    map(response => {
      return response.payload
        ? JSON.parse(response.payload) as { status: string, facility?: any, [key: string]: any}
        : undefined;
    }),
    filter(Boolean),
    tap(response => {
      // callers of onFacilityUpdate always send the full facility record alongside status 'UPDATED'
      if (response.status === 'UPDATED' && response.facility) {
        appState.set('currentFacility', {
          ...response.facility,
          id: response.facility.id || response.facility.pk,
        });
      }
    })
  );
}
